var map = {
	"./admin.svg": "0349",
	"./bowl.svg": "6be4",
	"./check.svg": "7bae",
	"./circle.svg": "b289",
	"./close.svg": "8b1b",
	"./community.svg": "5747",
	"./cube.svg": "e952",
	"./dashed-semicircle.svg": "fdcf",
	"./facebook.svg": "8485",
	"./fb.svg": "55c7",
	"./game.svg": "dfde",
	"./google.svg": "d950",
	"./hamburger.svg": "f5d5",
	"./ig.svg": "4f35",
	"./next-arrow.svg": "73f4",
	"./next.svg": "0043",
	"./payments/appstore.svg": "7251",
	"./payments/googleplay.svg": "51b2",
	"./payments/paypal.svg": "e59c",
	"./play-button.svg": "7d05",
	"./price.svg": "2eda",
	"./retire.svg": "4a2e",
	"./safe.svg": "ce81",
	"./scroll-mobile.svg": "4e14",
	"./scroll.svg": "5dd7",
	"./secure.svg": "2390",
	"./triangle.svg": "a8fe",
	"./trophy.svg": "e6bc",
	"./user.svg": "6aed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";